// Utilitários para formatação de moeda

export const formatCurrency = (value) => {
  const numValue = parseFloat(value) || 0;
  return numValue.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  });
};

export const parseCurrency = (value) => {
  if (typeof value === 'number') return value;
  if (typeof value === 'string') {
    return parseFloat(value.replace(/[^\d,.-]/g, '').replace(',', '.')) || 0;
  }
  return 0;
};

export const formatPrice = (value) => {
  const numValue = parseFloat(value) || 0;
  return `R$ ${numValue.toFixed(2).replace('.', ',')}`;
};